import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Work Orders
export const getWorkOrders = (params = {}) => axios.get(`${API_URL}/work-orders`, { params });
export const getWorkOrder = (id) => axios.get(`${API_URL}/work-orders/${id}`);
export const createWorkOrder = (data) => axios.post(`${API_URL}/work-orders`, data);
export const updateWorkOrder = (id, data) => axios.put(`${API_URL}/work-orders/${id}`, data);
export const deleteWorkOrder = (id) => axios.delete(`${API_URL}/work-orders/${id}`);
export const archiveWorkOrder = (id) => axios.post(`${API_URL}/work-orders/${id}/archive`);
export const unarchiveWorkOrder = (id) => axios.post(`${API_URL}/work-orders/${id}/unarchive`);
export const getArchivedWorkOrders = (params = {}) => axios.get(`${API_URL}/work-orders/archived/list`, { params });
export const getEquipmentTypes = () => axios.get(`${API_URL}/equipment-types`);

// Stations
export const getStations = () => axios.get(`${API_URL}/stations`);
export const createStation = (name, location) => axios.post(`${API_URL}/stations`, null, { params: { name, location } });
export const deleteStation = (id) => axios.delete(`${API_URL}/stations/${id}`);

// Messages
export const getMessages = (workOrderId) => axios.get(`${API_URL}/messages/${workOrderId}`);
export const createMessage = (data) => axios.post(`${API_URL}/messages`, data);

// Direct Messages / Chat
export const getConversations = () => axios.get(`${API_URL}/conversations`);
export const getConversationMessages = (userId) => axios.get(`${API_URL}/conversations/${userId}`);
export const sendDirectMessage = (recipientId, content) => axios.post(`${API_URL}/conversations/${recipientId}`, { recipient_id: recipientId, content });
export const getChatUsers = () => axios.get(`${API_URL}/chat/users`);
export const getUnreadMessageCount = () => axios.get(`${API_URL}/chat/unread-count`);

// Photos
export const getPhotos = (workOrderId, tag) => axios.get(`${API_URL}/photos/${workOrderId}`, { params: { tag } });
export const uploadPhoto = (formData) => axios.post(`${API_URL}/photos/upload`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deletePhoto = (id) => axios.delete(`${API_URL}/photos/${id}`);
export const downloadPhotosZip = (workOrderId) => axios.get(`${API_URL}/photos/${workOrderId}/download-zip`, { responseType: 'blob' });

// Documents
export const getDocuments = (workOrderId, category) => axios.get(`${API_URL}/documents/${workOrderId}`, { params: { category } });
export const uploadDocument = (formData) => axios.post(`${API_URL}/documents/upload`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const togglePinDocument = (id, isPinned) => axios.put(`${API_URL}/documents/${id}/pin`, null, { params: { is_pinned: isPinned } });
export const getDocumentCategories = () => axios.get(`${API_URL}/document-categories`);
export const getDocumentVersions = (workOrderId, filename) => axios.get(`${API_URL}/documents/${workOrderId}/versions/${encodeURIComponent(filename)}`);

// Bulletins
export const getBulletins = (params = {}) => axios.get(`${API_URL}/bulletins`, { params });
export const createBulletin = (data) => axios.post(`${API_URL}/bulletins`, data);
export const acknowledgeBulletin = (id) => axios.post(`${API_URL}/bulletins/${id}/acknowledge`);

// Weather
export const getWeather = (workOrderId) => axios.get(`${API_URL}/weather/${workOrderId}`);
export const getWeatherSettings = (workOrderId) => axios.get(`${API_URL}/weather-settings/${workOrderId}`);
export const updateWeatherSettings = (data) => axios.post(`${API_URL}/weather-settings`, data);

// Lessons Learned
export const getLessons = (params = {}) => axios.get(`${API_URL}/lessons`, { params });
export const createLesson = (data) => axios.post(`${API_URL}/lessons`, data);
export const getLessonRecommendations = (workOrderId) => axios.get(`${API_URL}/lessons/recommendations/${workOrderId}`);

// Ask Stewie
export const askStewie = (question, workOrderId) => axios.post(`${API_URL}/ask-stewie`, { question, work_order_id: workOrderId });
export const checkViolation = (eventType, eventDescription, workOrderId) => 
  axios.post(`${API_URL}/violation-check`, { event_type: eventType, event_description: eventDescription, work_order_id: workOrderId });

// Quick Canvass
export const getCanvassRequests = (workOrderId) => axios.get(`${API_URL}/canvass/requests`, { params: { work_order_id: workOrderId } });
export const createCanvassRequest = (data) => axios.post(`${API_URL}/canvass/request`, data);
export const respondToCanvass = (requestId, accepted, position) => 
  axios.post(`${API_URL}/canvass/respond/${requestId}`, null, { params: { accepted, position } });
export const getAvailableCrews = () => axios.get(`${API_URL}/canvass/available-crews`);
export const assignCrewToWorkOrder = (workOrderId, crewData) => axios.post(`${API_URL}/work-orders/${workOrderId}/assign-crew`, crewData);
export const unassignCrewFromWorkOrder = (workOrderId) => axios.delete(`${API_URL}/work-orders/${workOrderId}/unassign-crew`);

// Reports
export const getProjectReport = (workOrderId) => axios.get(`${API_URL}/reports/project/${workOrderId}`);
export const getDailyReport = (workOrderId, date) => axios.get(`${API_URL}/reports/daily/${workOrderId}`, { params: { date } });
export const downloadPdfReport = (workOrderId) => axios.get(`${API_URL}/reports/pdf/${workOrderId}`, { responseType: 'blob' });
export const downloadWorkOrdersCsv = (params = {}) => axios.get(`${API_URL}/reports/csv/workorders`, { params, responseType: 'blob' });
export const downloadSingleWorkOrderCsv = (workOrderId) => axios.get(`${API_URL}/reports/csv/workorder/${workOrderId}`, { responseType: 'blob' });

// Safety Briefing
export const generateSafetyBriefing = (workOrderId) => axios.get(`${API_URL}/safety-briefing/${workOrderId}`);

// Notifications
export const getNotifications = () => axios.get(`${API_URL}/notifications`);
export const markNotificationRead = (id) => axios.post(`${API_URL}/notifications/${id}/read`);
export const markAllNotificationsRead = () => axios.post(`${API_URL}/notifications/read-all`);

// Events/Timeline
export const getEvents = (workOrderId) => axios.get(`${API_URL}/events/${workOrderId}`);

// Dashboard
export const getDashboard = () => axios.get(`${API_URL}/dashboard`);

// Workflow Automation
export const getJobsNeedingAttention = () => axios.get(`${API_URL}/workflow/jobs-needing-attention`);
export const generateJobPacket = (workOrderId, options = {}) => axios.post(`${API_URL}/workflow/generate-job-packet/${workOrderId}`, options);
export const getWorkflowStatus = (workOrderId) => axios.get(`${API_URL}/workflow/status/${workOrderId}`);
export const supervisorOverride = (workOrderId, action, justification) => 
  axios.post(`${API_URL}/workflow/supervisor-override/${workOrderId}`, null, { params: { action, justification } });
export const regenerateSafetyBrief = (workOrderId) => axios.post(`${API_URL}/workflow/regenerate-safety/${workOrderId}`);
export const runRiskAssessment = (workOrderId) => axios.post(`${API_URL}/workflow/run-risk-assessment/${workOrderId}`);

// Users
export const getUsers = () => axios.get(`${API_URL}/users`);
export const updateUserRole = (userId, role) => axios.put(`${API_URL}/users/${userId}/role`, null, { params: { role } });

// Admin
export const uploadAdminBook = (bookType, content) => axios.post(`${API_URL}/admin/books`, new URLSearchParams({ book_type: bookType, content }));
export const getAdminBook = (bookType) => axios.get(`${API_URL}/admin/books/${bookType}`);

// Admin Dropdown Options
export const getDropdownOptions = (category) => axios.get(`${API_URL}/admin/dropdown-options${category ? `/${category}` : ''}`);
export const createDropdownOption = (data) => axios.post(`${API_URL}/admin/dropdown-options`, data);
export const updateDropdownOption = (optionId, data) => axios.put(`${API_URL}/admin/dropdown-options/${optionId}`, data);
export const deleteDropdownOption = (optionId) => axios.delete(`${API_URL}/admin/dropdown-options/${optionId}`);
export const seedDropdownOptions = () => axios.post(`${API_URL}/admin/seed-dropdown-options`);

// Logistics / Equipment Requests
export const createLogisticsRequest = (data) => axios.post(`${API_URL}/logistics/request`, data);
export const getLogisticsRequests = (params = {}) => axios.get(`${API_URL}/logistics/requests`, { params });
export const getLogisticsRequest = (requestId) => axios.get(`${API_URL}/logistics/requests/${requestId}`);
export const updateLogisticsStatus = (requestId, data) => axios.put(`${API_URL}/logistics/requests/${requestId}/status`, data);

// Enhanced AskStewie
export const generateTagBasedSafety = (workOrderId, tags, sources = ["SAFETY", "UNION"], context = null) => 
  axios.post(`${API_URL}/askstewie/tag-based-safety`, { work_order_id: workOrderId, tags, sources, context });

// Download History
export const getDownloadHistory = (params = {}) => axios.get(`${API_URL}/downloads/history`, { params });
export const getAllDownloadHistory = (params = {}) => axios.get(`${API_URL}/downloads/history/all`, { params });
export const deleteDownloadRecord = (downloadId) => axios.delete(`${API_URL}/downloads/history/${downloadId}`);
export const recordDownload = (data) => axios.post(`${API_URL}/downloads/record`, data);

// Audit
export const getAuditLogs = (params = {}) => axios.get(`${API_URL}/audit-logs`, { params });

// Daily Progress Reports
export const submitDailyProgress = (workOrderId, data) => axios.post(`${API_URL}/work-orders/${workOrderId}/daily-progress`, data);
export const getDailyProgressReports = (workOrderId, limit = 100) => axios.get(`${API_URL}/work-orders/${workOrderId}/daily-progress`, { params: { limit } });
export const getDailyProgressReport = (workOrderId, reportId) => axios.get(`${API_URL}/work-orders/${workOrderId}/daily-progress/${reportId}`);
export const updateDailyProgress = (workOrderId, reportId, data) => axios.put(`${API_URL}/work-orders/${workOrderId}/daily-progress/${reportId}`, data);
export const addPhotosToDailyProgress = (workOrderId, reportId, photoIds) => axios.post(`${API_URL}/work-orders/${workOrderId}/daily-progress/${reportId}/photos`, photoIds);
export const getDailyProgressTodayStatus = () => axios.get(`${API_URL}/daily-progress/today-status`);
export const getMissingReports = () => axios.get(`${API_URL}/daily-progress/missing-reports`);
export const sendProgressReminders = () => axios.post(`${API_URL}/daily-progress/send-reminders`);
export const getMyWorkOrders = (status) => axios.get(`${API_URL}/my-workorders`, { params: status ? { status } : {} });

// Supervisor Review Mode
export const getSupervisorReviewDashboard = (params = {}) => axios.get(`${API_URL}/supervisor/review-dashboard`, { params });
export const getSupervisorDailyReport = (reportId) => axios.get(`${API_URL}/supervisor/daily-report/${reportId}`);
export const approveDailyReport = (reportId, comment = null) => axios.post(`${API_URL}/supervisor/daily-report/${reportId}/approve`, { comment });
export const requestChanges = (reportId, message) => axios.post(`${API_URL}/supervisor/daily-report/${reportId}/request-changes`, { message });
export const escalateDailyReport = (reportId, escalationType, details) => axios.post(`${API_URL}/supervisor/daily-report/${reportId}/escalate`, { escalation_type: escalationType, details });
export const addInternalNote = (reportId, note) => axios.post(`${API_URL}/supervisor/daily-report/${reportId}/internal-note`, { note });
export const reassignWorkOrder = (workOrderId, newCrewLeaderId, reason = null) => axios.post(`${API_URL}/workorders/${workOrderId}/reassign`, { new_crew_leader_id: newCrewLeaderId, reason });
export const getWorkOrderReviewHistory = (workOrderId) => axios.get(`${API_URL}/supervisor/review-history/${workOrderId}`);
export const getSupervisorSettings = () => axios.get(`${API_URL}/supervisor/settings`);
export const updateSupervisorSettings = (reviewDeadlineHour) => axios.put(`${API_URL}/supervisor/settings`, null, { params: { review_deadline_hour: reviewDeadlineHour } });

// Scheduling & Calendar
export const getSchedulingTimeline = (params = {}) => axios.get(`${API_URL}/scheduling/timeline`, { params });
export const getSchedulingCalendar = (startDate, endDate, viewType = 'all') => axios.get(`${API_URL}/scheduling/calendar`, { params: { start_date: startDate, end_date: endDate, view_type: viewType } });
export const getCrewCalendar = (startDate, endDate) => axios.get(`${API_URL}/scheduling/crew-calendar`, { params: { start_date: startDate, end_date: endDate } });
export const updateWorkOrderSchedule = (workOrderId, data) => axios.put(`${API_URL}/work-orders/${workOrderId}/schedule`, data);
export const updateMilestone = (workOrderId, milestoneName, data) => axios.put(`${API_URL}/work-orders/${workOrderId}/milestones/${milestoneName}`, data);
export const initializeMilestones = (workOrderId) => axios.post(`${API_URL}/work-orders/${workOrderId}/initialize-milestones`);
export const getResources = (resourceType = null) => axios.get(`${API_URL}/scheduling/resources`, { params: resourceType ? { resource_type: resourceType } : {} });
export const createResourceAllocation = (data) => axios.post(`${API_URL}/scheduling/resources`, data);
export const deleteResourceAllocation = (allocationId) => axios.delete(`${API_URL}/scheduling/resources/${allocationId}`);

// Google Calendar
export const getGoogleAuthUrl = () => axios.get(`${API_URL}/calendar/google/auth-url`);
export const getGoogleCalendarStatus = () => axios.get(`${API_URL}/calendar/google/status`);
export const disconnectGoogleCalendar = () => axios.post(`${API_URL}/calendar/google/disconnect`);
export const syncWorkOrderToGoogle = (workOrderId) => axios.post(`${API_URL}/calendar/google/sync-work-order/${workOrderId}`);
export const getGoogleCalendarEvents = (startDate, endDate) => axios.get(`${API_URL}/calendar/google/events`, { params: { start_date: startDate, end_date: endDate } });

// Schedule Upload & Work Order Drafts
export const uploadSchedule = (formData) => axios.post(`${API_URL}/schedules/upload`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const importSchedule = (uploadId, sheets = null) => axios.post(`${API_URL}/schedules/${uploadId}/import`, null, { 
  params: sheets ? { sheets: sheets.join(',') } : {} 
});
export const getScheduleUploads = (status = null) => axios.get(`${API_URL}/schedules`, { params: status ? { status } : {} });
export const getScheduleUpload = (uploadId) => axios.get(`${API_URL}/schedules/${uploadId}`);
export const getScheduleItems = (uploadId, params = {}) => axios.get(`${API_URL}/schedules/${uploadId}/items`, { params });
export const getShortRangeSchedule = (uploadId) => axios.get(`${API_URL}/schedules/${uploadId}/short-range`);
export const getLongRangeSchedule = (uploadId) => axios.get(`${API_URL}/schedules/${uploadId}/long-range`);
export const deleteScheduleUpload = (uploadId) => axios.delete(`${API_URL}/schedules/${uploadId}`);

// Work Order Drafts
export const getWorkOrderDrafts = (params = {}) => axios.get(`${API_URL}/work-order-drafts`, { params });
export const getWorkOrderDraft = (draftId) => axios.get(`${API_URL}/work-order-drafts/${draftId}`);
export const updateWorkOrderDraft = (draftId, data) => axios.put(`${API_URL}/work-order-drafts/${draftId}`, data);
export const activateWorkOrderDraft = (draftId, data = {}) => axios.post(`${API_URL}/work-order-drafts/${draftId}/activate`, data);
export const rejectWorkOrderDraft = (draftId, reason = null) => axios.post(`${API_URL}/work-order-drafts/${draftId}/reject`, null, { params: reason ? { reason } : {} });
export const bulkActivateDrafts = (draftIds) => axios.post(`${API_URL}/work-order-drafts/bulk-activate`, draftIds);

// Crew Requirements & Crew Requests
export const updateCrewRequirements = (workOrderId, requirements) => axios.put(`${API_URL}/work-orders/${workOrderId}/crew-requirements`, requirements);
export const getCrewRequirements = (workOrderId) => axios.get(`${API_URL}/work-orders/${workOrderId}/crew-requirements`);
export const getWorkOrderCrewRequest = (workOrderId) => axios.get(`${API_URL}/work-orders/${workOrderId}/crew-request`);
export const queueCrewRequest = (workOrderId, data = {}) => axios.post(`${API_URL}/work-orders/${workOrderId}/queue-crew-request`, data);
export const createCrewRequest = (data) => axios.post(`${API_URL}/crew-requests`, data);
export const getCrewRequests = (params = {}) => axios.get(`${API_URL}/crew-requests`, { params });
export const getCrewRequest = (requestId) => axios.get(`${API_URL}/crew-requests/${requestId}`);
export const startCrewRequest = (requestId, data = {}) => axios.post(`${API_URL}/crew-requests/${requestId}/start`, data);
export const cancelCrewRequest = (requestId, data = {}) => axios.post(`${API_URL}/crew-requests/${requestId}/cancel`, data);
export const completeCrewRequest = (requestId) => axios.post(`${API_URL}/crew-requests/${requestId}/complete`);

// Canvass Windows
export const getCanvassWindows = (params = {}) => axios.get(`${API_URL}/canvass-windows`, { params });
export const getCanvassWindow = (windowId) => axios.get(`${API_URL}/canvass-windows/${windowId}`);
export const expressInterestInCanvass = (windowId, role) => axios.post(`${API_URL}/canvass-windows/${windowId}/express-interest`, null, { params: { role } });
export const assignUserToCanvass = (windowId, userId, role) => axios.post(`${API_URL}/canvass-windows/${windowId}/assign`, null, { params: { user_id: userId, role } });

// Seed
export const seedData = () => axios.post(`${API_URL}/seed`);

